import ListItemButton from '@mui/material/ListItemButton';
import {useTheme,styled } from '@mui/material/styles'
import {useNavigate} from 'react-router-dom'
import { IconButton, Typography } from '@mui/material';

const CardButton = styled((props) => (
  <ListItemButton elevation={5}  {...props} />
))(({ theme }) => ({
  
  '&:focus': {
     background:'transparent',
     borderRadius:5
  },
}));
const Item = ({name,children,open,route})=>{

	const theme = useTheme();
	const navigate = useNavigate()

	return(
	<CardButton onClick={()=>{route ? navigate(`${route}`) : null}}  sx={{elevation:4}}>
	    <IconButton sx={{minWidth: 0,mr: 1,justifyContent: 'center',}}>
	        {children}
	    </IconButton>
		<Typography sx={{fontSize:12,fontFamily:"dinofans"}}>
			{name}
		</Typography>
    </CardButton>

	)
}

export default Item